import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useEffect, useState } from 'react'

interface ModalErrorMessageProps {
  data: ErrorResponse
  setData: React.Dispatch<React.SetStateAction<boolean>>
  title?: string
  footer?: string
  message?: string
}

export const ModalErrorMessage = ({ data, setData, title, footer, message }: ModalErrorMessageProps) => {
  const [messages, setMessages] = useState<{ errors?: string[]; request_id?: string }>({ errors: [], request_id: '' })

  useEffect(() => {
    if (data) {
      setMessages({
        errors: data?.response?.data?.errors?.base,
        request_id: data?.response?.data?.request_id,
      })
    }
  }, [data?.response?.data?.request_id, data?.response?.data?.errors?.base])

  return (
    <Modal
      isOpen={!!data}
      setIsOpen={setData}
      onConfirm={() => setData(false)}
      title={title || 'Operação não concluída'}
      footer={footer || 'Entendido!'}
      dataTestid="message_confirm_button"
      titleClass="text-danger-soft"
      body={
        <div className="flex flex-col gap-4 py-2">
          <div className="flex flex-col gap-2 py-2">
            <p className="text-[16px]">{message || 'Algo deu errado.'}</p>
          </div>

          <div>
            <p className="text-[14px] font-light">ID da requisição</p>
            <p className="text-[16px] text-2xl text-muted">{messages.request_id}</p>
          </div>

          <div>
            <p className="text-[14px] font-light">Erros</p>

            {messages?.errors?.map((message, index) => (
              <p key={index} className="text-[16px] text-2xl text-muted">
                - {message}
              </p>
            ))}
          </div>
        </div>
      }
    />
  )
}
